import { Reveal } from "../components/Reveal";
import { PhoneCall, CalendarCheck, Car, Trophy } from "lucide-react";

const STEPS = [
  { icon: PhoneCall, title: "Get in Touch", text: "Call, WhatsApp or request a free quote. Tell us your goals and availability." },
  { icon: CalendarCheck, title: "Book Your Lesson", text: "Pick your lesson type, package and preferred times. We arrange a suitable local collection point, subject to availability." },
  { icon: Car, title: "Learn & Progress", text: "Structured lessons with honest feedback and progress tracking every step." },
  { icon: Trophy, title: "Pass with Confidence", text: "Use mock tests and instructor feedback to approach the practical test calmly and independently." },
];

export function HowItWorks() {
  return (
    <section id="how" className="section-pad" data-testid="how-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <Reveal>
          <span className="overline">How It Works</span>
          <h2 className="mt-3 font-heading text-4xl sm:text-5xl font-extrabold tracking-tight max-w-xl">
            Your road to a licence in <span className="brand-text">four steps</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-4 gap-6 relative">
          <div className="hidden md:block absolute top-8 left-[12%] right-[12%] h-0.5 bg-gradient-to-r from-brand-red via-brand-orange to-brand-amber opacity-30" />
          {STEPS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.1}>
              <div className="relative text-center">
                <div className="mx-auto w-16 h-16 rounded-2xl brand-gradient text-white flex items-center justify-center shadow-glow relative z-10">
                  <s.icon size={26} strokeWidth={1.8} />
                  <span className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-neutral-900 text-white text-xs font-bold flex items-center justify-center">{i + 1}</span>
                </div>
                <h3 className="mt-5 font-heading text-lg font-bold">{s.title}</h3>
                <p className="mt-2 text-sm text-neutral-500 leading-relaxed">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
